// import router from '@/router';

import { API, graphqlOperation } from 'aws-amplify';
import { sequenceIncrement, executeTransaction } from '@/graphql/mutations';
import { SEQUENCE_TYPE } from '@/assets/js/const';

export const executeApi = async (apiObject, input = null) => {
  try {
    const result = await API.graphql(input ? graphqlOperation(apiObject, input) : graphqlOperation(apiObject));
    return result;
  } catch (error) {
    // TODO:ログインしていない場合のエラー内容を調べる
    console.log('executeApi error', error);
    // TODO:ログインしていないエラーの場合だけここでアラートを出してログイン画面遷移
    throw error;
    // TODO:Vuetifyのモーダルをここで表示する方法
    // alert('APIを実行する権限がありません。ログアウトしている可能性があります。ログイン画面に遷移します');
    // router.push('/login');
  }
};

/**
 * ユーザーIDの連番を取得
 * @returns user_id
 */
export const getUserNoSequence = async () => {
  try {
    const result = await executeApi(sequenceIncrement, { Type: SEQUENCE_TYPE.USER_NO });
    return result.data.sequenceIncrement.CurrentNumber;
  } catch (error) {
    // TODO:ログインしていない場合のエラー内容を調べる
    // TODO:ログインしていないエラーの場合だけここでアラートを出してログイン画面遷移
    // TODO:スローエラー
    // TODO:Vuetifyのモーダルをここで表示する方法
    alert('APIを実行する権限がありません。ログアウトしている可能性があります。ログイン画面に遷移します');
    // router.push('/login');
  }
};

export const getNewsIdSequence = async () => {
  try {
    const result = await executeApi(sequenceIncrement, { Type: SEQUENCE_TYPE.NEWS_ID });
    return result.data.sequenceIncrement.CurrentNumber;
  } catch (error) {
    // TODO:ログインしていない場合のエラー内容を調べる
    // TODO:ログインしていないエラーの場合だけここでアラートを出してログイン画面遷移
    // TODO:スローエラー
    // TODO:Vuetifyのモーダルをここで表示する方法
    alert('APIを実行する権限がありません。ログアウトしている可能性があります。ログイン画面に遷移します');
    // router.push('/login');
  }
};

/**
 *
 * @param {*} items arrｙ
 * @returns {statusCode,body}
 */
export const executeTransactionApi = async (items) => {
  try {
    if (items.length == 0) {
      console.log('executeTransactionApi items length 0');
      return;
    }

    let input = [];
    items.forEach((item) => {
      var conditionExpression;
      var expressionAttributeNames;
      var expressionAttributeValues = {};
      var updateExpression = [];
      switch (item.operation) {
        case 'Put':
          if (item.attribute_not_exist.SK) {
            conditionExpression = `attribute_not_exists(#PK) AND attribute_not_exists(#SK)`;
            expressionAttributeNames = {
              '#PK': item.attribute_not_exist.PK,
              '#SK': item.attribute_not_exist.SK,
            };
          } else {
            conditionExpression = `attribute_not_exists(#PK)`;
            expressionAttributeNames = {
              '#PK': item.attribute_not_exist.PK,
            };
          }
          input.push({
            operation: item.operation,
            targetTable: item.targetTable,
            item: JSON.stringify(item.item),
            conditionExpression: conditionExpression,
            expressionAttributeNames: JSON.stringify(expressionAttributeNames),
          });
          break;
        case 'Update':
          if (item.attribute_exist.SK) {
            conditionExpression = `attribute_exists(#PK) AND attribute_exists(#SK)`;
            expressionAttributeNames = {
              '#PK': item.attribute_exist.PK,
              '#SK': item.attribute_exist.SK,
            };
          } else {
            conditionExpression = `attribute_exists(#PK)`;
            expressionAttributeNames = {
              '#PK': item.attribute_exist.PK,
            };
          }
          item.update_field.forEach((update_field) => {
            expressionAttributeNames[`#${update_field.key}`] = update_field.key;
            expressionAttributeValues[`:${update_field.key}`] = update_field.value;
            updateExpression.push(`#${update_field.key} = :${update_field.key}`);
          });
          input.push({
            operation: item.operation,
            targetTable: item.targetTable,
            key: JSON.stringify(item.key),
            updateExpression: `SET ${updateExpression.join()}`,
            conditionExpression: conditionExpression,
            expressionAttributeNames: JSON.stringify(expressionAttributeNames),
            expressionAttributeValues: JSON.stringify(expressionAttributeValues),
          });
          break;
        case 'Delete':
          input.push({
            operation: item.operation,
            targetTable: item.targetTable,
            key: JSON.stringify(item.key),
          });
          break;
        default:
          input.push({});
      }
    });
    console.log('input', input);
    let accessLimit = 100;
    let result = null;
    const accessCount = input.length / accessLimit;
    for (let index = 0; index < accessCount; index++) {
      const inputTemp = input.splice(0, accessLimit);
      result = await executeApi(executeTransaction, { items: inputTemp });
      if (result.data.executeTransaction.statusCode != 200) {
        console.log('statusCode', result.data.executeTransaction.statusCode);
        console.log('body', result.data.executeTransaction.body);
        return result.data.executeTransaction;
      }
    }
    console.log('statusCode', result.data.executeTransaction.statusCode);
    console.log('body', result.data.executeTransaction.body);
    return result.data.executeTransaction;
  } catch (error) {
    // TODO:ログインしていない場合のエラー内容を調べる
    console.log('executeTransactionApi error', error);
    // TODO:ログインしていないエラーの場合だけここでアラートを出してログイン画面遷移
    throw error;
    // TODO:Vuetifyのモーダルをここで表示する方法
    // alert('APIを実行する権限がありません。ログアウトしている可能性があります。ログイン画面に遷移します');
    // router.push('/login');
  }
};
